import { CodeBase } from "./_codeBase";

/** ユーザー区分*/
export class UserDiv extends CodeBase<UserDiv>
{
    /** ユーザー区分: "00", "管理者"*/
    public static readonly ADMIN: UserDiv = new UserDiv("00", "管理者", "");
    /** ユーザー区分: "01", "プロジェクト別"*/
    public static readonly BY_PROJECT: UserDiv = new UserDiv("01", "プロジェクト別", "");
    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): UserDiv[] {
        return [
            UserDiv.ADMIN,
            UserDiv.BY_PROJECT,
        ];
    }
}
